import { render, staticRenderFns } from "./InventoryForm.vue?vue&type=template&id=aa33c0b6"
import script from "./InventoryForm.vue?vue&type=script&lang=js"
export * from "./InventoryForm.vue?vue&type=script&lang=js"
import style0 from "./InventoryForm.vue?vue&type=style&index=0&id=aa33c0b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports